if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    const { RichText } = window.wp.editor;

    registerBlockType('custom-gutenberg/tour-heading', {
        title: 'Tour Heading',
        description: 'Tour title with an eyebrow.',
        icon: 'heading',
        category: 'custom-content',
        example: {},

        attributes: {
            eyebrow: { type: 'string', default: '' },
            title: { type: 'string', default: '' }
        },

        edit({ attributes, setAttributes }) {
            const { eyebrow, title } = attributes;

            return (
                <div className="tour-heading-section">
                    <RichText
                        tagName="span"
                        className="eyebrow"
                        allowedFormats={ ['core/bold', 'core/italic', 'core/text-color'] }
                        value={ eyebrow }
                        placeholder="SAORSA / OFFROAD 4×4"
                        onChange={ eyebrow => setAttributes({ eyebrow: eyebrow }) }
                    />
                    <RichText
                        tagName="h1"
                        className="tour-heading"
                        allowedFormats={ ['core/bold', 'core/italic', 'core/text-color'] }
                        value={ title }
                        placeholder="Naziv ture"
                        onChange={ title => setAttributes({ title: title }) }
                    />
                </div>
            );
        },

        save({ attributes }) {
            return (
                <div className="tour-heading-section">
                    <span className="eyebrow"><RichText.Content value={ attributes.eyebrow } /></span>
                    <RichText.Content tagName="h1" className="tour-heading" value={ attributes.title } />
                </div>
            );
        }
    });
}
